import { TypeActivePicture } from './activePicture';
import { CriticalType, ValueType } from './results';
import { TextId } from './textSelector';

export enum AnswerAction {
  DoAction = 'doAction',
  DoNextTask = 'doNextTask',
  DoPrevTask = 'doPrevTask',
  DoTest = 'doTest',
  DoTestIdent = 'doTestIdent',
}

enum ShowConditionally {
  AnyAnswer = 'any-answer', ///pokazuje jak jest udzielona jakakolwiek odpowiedź
  CorrectLastAnswer = 'correct-last-answer', // pokazuje tylko gdy odpowiedź jest prawidłowa
  AfterMinTime = 'after-min-time', // pokazuje po upływie minimalnego czasu prezentacji
}

export type Answer = CoreAnswer & SpriteObject;
export type TaskNumber = string;
export type ConditionNextTask = {
  condition: CodeAnswer[];
  task: TaskNumber;
  other: TaskNumber | ConditionNextTask;
};

type SpriteObject = {
  action?: AnswerAction;
  calculated?: boolean;
  param?: string;
  condition_next_task?: ConditionNextTask;
  input?: boolean;
  input_type?: string;
  on_change?: string;
  accept?: string;
  multiple?: boolean;
  file_preview?: boolean;
  textarea?: boolean;
  next_task?: TaskNumber;
  presentation_class?: string;
  presentation_addclass?: string;
  show_conditionally?: ShowConditionally;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  animation?: { param: any; speed: number }[];
  left?: number;
  top?: number;
  width?: number;
  height?: number;
  text?: TextId;
  img?: string;
  svg?: string;
  active_picture?: TypeActivePicture;
  param_check_complex?: number[];
  drawing?: boolean;
  scanner?: boolean;
};

export type CodeAnswer = string;

export type CoreFieldName = string;

type CoreAnswer = {
  code: CodeAnswer; //odpowiedź
  correct?: boolean; // czy to prawidłowa odpowiedź
  default_value?: string;
  core_field_name?: CoreFieldName; // powiązane pole w bazie
  critical_type?: CriticalType; // oznaczenie krytycznych punktów / odpowiedzi do analizy po stronie prowadzącego badanie
  value_type?: ValueType; // oznaczenie typu zwracanej wartości
  is_selected?: boolean;
  complex?: boolean;
  standard_value?: string;
  pattern?: string;
  required?: boolean;
  repeat_value?: string;
  text?: TextId; /// zdekodowana odpowiedź - tu jest wyzwanie czy ja mam wydowbywać z tekstów czy tylko textId zwrócić (rozpakowane raczej bez sensu bo tylko jeden język???)
  textPL?: TextId; /// do arkuszy zawsze chcemy odpowiedzi po polsku ^rozwiązanie bez rozpakowywania
  task_result_text?: string; ///tekst generowany na podstawie udzielonej odpowiedzi
  task_result_video?: string; /// obraz generowanie na podstawie nagrania zapisanego w podanym zadaniu
  task_result_stetho?: string; /// iframe generowanie na podstawie nagrania zapisanego w podanym zadaniu
};
